import { useQuery } from 'react-query';

import { axios } from 'lib/axios';

const getDirectSettings = async (directId) => {
  const {
    data: { data: settings },
  } = await axios.get(`/api/directs/${directId}/settings`);
  return settings;
};

export const useDirectSettings = (directId, queryOptions = {}) =>
  useQuery(['direct-settings', directId], () => getDirectSettings(directId), {
    initialData: [],
    enabled: !!directId,
    ...queryOptions,
  });
